storefrontApp.service("suggestionsService", 
    ["$http",
    function ( $http ) {
        return{
            submitSuggestion: function(formData){
                return $http.post(
                    "storefrontapi/suggestion",
                    formData,
                    {
                        headers: { "Content-Type": undefined },
                    }
                );
            }
        }
    }
]);